import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { FarmFireRiskChartTooltipFactory } from '../factories/FarmFireRiskChartTooltip.factory'
import { RecentFireRisk } from '@/@core/fire-risk-dashboard/domain/entities/RecentFireRisk'


export default /*#__PURE__*/_defineComponent({
  __name: 'FarmFireRiskChartTooltip.factory',
  props: {
    farm: null
  },
  setup(__props: any) {

const { farm } = __props as {
	farm: RecentFireRisk
};



const tooltipInfo = computed(() => FarmFireRiskChartTooltipFactory.make(farm))

return { __sfc: true,tooltipInfo }
}

})